export const CREATE_SPIN_GAME_MESSAGE_REQUEST =
	"CREATE_SPIN_GAME_MESSAGE_REQUEST";
export const CREATE_SPIN_GAME_MESSAGE_SUCCESS =
	"CREATE_SPIN_GAME_MESSAGE_SUCCESS";
export const CREATE_SPIN_GAME_MESSAGE_FAIL = "CREATE_SPIN_GAME_MESSAGE_FAIL";
export const RESET_DELETE_SPIN_GAME_MESSAGE = "RESET_DELETE_SPIN_GAME_MESSAGE";
export const FETCH_SPIN_GAME_MESSAGES_REQUEST =
	"FETCH_SPIN_GAME_MESSAGES_REQUEST";
export const FETCH_SPIN_GAME_MESSAGES_SUCCESS =
	"FETCH_SPIN_GAME_MESSAGES_SUCCESS";
export const FETCH_SPIN_GAME_MESSAGES_FAIL = "FETCH_SPIN_GAME_MESSAGES_FAIL";
export const UPDATE_SPIN_GAME_MESSAGE_REQUEST =
	"UPDATE_SPIN_GAME_MESSAGE_REQUEST";
export const UPDATE_SPIN_GAME_MESSAGE_SUCCESS =
	"UPDATE_SPIN_GAME_MESSAGE_SUCCESS";
export const UPDATE_SPIN_GAME_MESSAGE_FAIL = "UPDATE_SPIN_GAME_MESSAGE_FAIL";
export const DELETE_SPIN_GAME_MESSAGE_REQUEST =
	"DELETE_SPIN_GAME_MESSAGE_REQUEST";
export const DELETE_SPIN_GAME_MESSAGE_SUCCESS =
	"DELETE_SPIN_GAME_MESSAGE_SUCCESS";
export const DELETE_SPIN_GAME_MESSAGE_FAIL = "DELETE_SPIN_GAME_MESSAGE_FAIL";
export const FETCH_SPIN_GAME_MESSAGE_REQUEST =
	"FETCH_SPIN_GAME_MESSAGE_REQUEST";
export const FETCH_SPIN_GAME_MESSAGE_SUCCESS =
	"FETCH_SPIN_GAME_MESSAGE_SUCCESS";
export const FETCH_SPIN_GAME_MESSAGE_FAIL = "FETCH_SPIN_GAME_MESSAGE_FAIL";
